import { makeAutoObservable } from 'mobx'
import { toastStore } from 'shared/ui'
import { ChatbotApi } from 'entities/Chatbot'
import type { IResponseFilterSegment } from 'entities/Segment'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { SendFromStore } from 'widgets/SendFrom'

export class ChatbotEnrollModalStore {
  private _sendFromStore
  error = ''

  constructor(private _entities: IEntitiesStore) {
    this._sendFromStore = new SendFromStore(this._entities, {
      personalInboxesOnly: true,
      withDynamicSender: this._entities.featureFlagsStore.send_as_contact_owner,
    })
    makeAutoObservable(this)
  }

  enrollContacts = ({
    agentId,
    contactIds,
    applyFilters,
  }: {
    agentId: number
    contactIds: number[]
    applyFilters: boolean
  }) =>
    ChatbotApi.enrollContactsInChatbot({
      chatbot_id: agentId,
      contact_ids: contactIds,
      apply_filters: applyFilters,
      send_from: this.sendFrom,
    }).then(
      () => {
        toastStore.add({
          type: 'success',
          title: applyFilters
            ? `Contact${
                contactIds.length > 1 ? 's' : ''
              } will be engaged if it matches enrollment criteria`
            : `Contact${contactIds.length > 1 ? 's' : ''} will be engaged by the AI Agent`,
        })

        return true
      },
      () => {
        toastStore.add({
          type: 'error',
          title: `Unable to engage contact${contactIds.length > 1 ? 's' : ''}`,
        })

        return false
      }
    )

  enrollContactsByFilters = ({
    agentId,
    inboxId,
    applyFilters,
    filtersList,
    search,
    bulkAll,
  }: {
    agentId: number
    inboxId?: number
    applyFilters: boolean
    filtersList?: IResponseFilterSegment[]
    search?: string
    bulkAll?: boolean
  }) =>
    ChatbotApi.enrollChatbot(agentId, {
      inbox_id: inboxId,
      apply_filters: applyFilters,
      contact_filters: filtersList,
      search,
      apply_to_all: bulkAll,
    }).then(
      () => {
        toastStore.add({
          type: 'success',
          title: applyFilters
            ? 'Contacts will be engaged if it matches enrollment criteria'
            : 'Contacts will be engaged by the AI Agent',
        })

        return true
      },
      () => {
        toastStore.add({
          type: 'error',
          title: 'Unable to engage contacts',
        })

        return false
      }
    )

  setError = (value: string) => {
    this.error = value
  }

  checkValidate = () => {
    let isValid = true

    if (!this.sendFrom) {
      this.setError('Please select the inbox to send from.')
      isValid = false
    } else {
      this.setError('')
    }

    return isValid
  }

  get sendFromStore() {
    return this._sendFromStore
  }

  get sendFrom() {
    return this._sendFromStore.paramsSendFrom
  }
}
